import api from "@/api"

const state = {
  merchants: [],
  merchantDetail: {},
  selfRegistration: []
}
const actions = {
  getMerchants({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.merchantList(params).then(
        (response) => {
          commit("setMerchants", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  addMerchant({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.addMerchant(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getMerchantDetail({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      api.merchant.merchantDetail(id).then(
        (response) => {
          commit("setMerchantDetail", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  editMerchant({ _ }, { id, payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.editMerchant(id, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteMerchant({ _ }, { id }) {
    return new Promise((resolve, reject) => {
      api.merchant.deleteMerchant(id).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  upgradeMerchant({ _ }, { payloads }) {
    console.log("testtt")
    return new Promise((resolve, reject) => {
      api.merchant.upgradeMerchant(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateApiKeyStatus({ _ }, { id, payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.updateApiKeyStatus(id, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getSelfRegistration({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.selfRegistration(params).then(
        (response) => {
          commit("setSelfRegistration", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  resendVerification({ _ }, { registerId }) {
    return new Promise((resolve, reject) => {
      api.merchant.resendVerification(registerId).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setMerchants(state, value) {
    state.merchants = value
  },
  setMerchantDetail(state, value) {
    state.merchantDetail = value
  },
  setSelfRegistration(state, value) {
    state.selfRegistration = value
  }
}
const getters = {
  merchants: (state) => state.merchants,
  merchantDetail: (state) => state.merchantDetail,
  selfRegistration: (state) => state.selfRegistration
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
